const translation = {
    'English': 'English',
    'Français': 'Français',
    'Español': 'Español',

    'Home': 'Inicio',
    'About': 'Nosotros',
    'Features': 'Características',
    'Stats': 'Estadísticas',
    'Process': 'Proceso',
    'Contact': 'Contacto',

    'Full Name': 'Nombre Completo',
    'Email Address': 'Correo Electrónico',
    'Phone Number': 'Número de Teléfono',
    'How can we help you?': '¿Cómo podemos ayudarte?',

    'i_agree_to_the': 'Acepto la',
    'Privacy Policy': 'Política de Privacidad',
    'and': 'y',
    'Terms of Service': 'Términos de Servicio',

    'Send Message': 'Enviar Mensaje',
    'Sending...': 'Enviando...',

    'Services': 'Servicios',
    'Web Design': 'Diseño Web',
    'Web Development': 'Desarrollo Web',
    'Cloud Services': 'Servicios en la Nube',
    'App Development': 'Desarrollo de Aplicaciones',
    'Business Consulting': 'Consultoría Empresarial',
    'Digital businesses': 'Negocios digitales',

    'Company': 'Empresa',
    'Portfolio': 'Portafolio',
    'Apps': 'Aplicaciones',
    'Websites': 'Sitios Web',
    'Business models': 'Modelos de negocio',

    'Connect': 'Conéctate',
    'Connect with us': 'Conecta con nosotros',
    'Instagram': 'Instagram',

    'Language': 'Idioma',
    'Open menu': 'Abrir menú',
    'Close menu': 'Cerrar menú',

    'Know more': 'Conocer más',
    'No projects available': 'No hay proyectos disponibles',

    'Project not found': 'Proyecto no encontrado',
    'We could not find the information for this project.': 'No pudimos encontrar la información de este proyecto.',
    'Back to home': 'Volver al inicio',

    'DANTRIX PRO / PROJECT': 'DANTRIX PRO / PROYECTO',
    'CASE STUDY': 'CASO DE ESTUDIO',

    '01 / PROJECT': '01 / PROYECTO',
    'BEHIND THE PROJECT': 'DETRÁS DEL PROYECTO',
    'Every solution starts by understanding the business, its needs and the goals it wants to achieve.': 'Cada solución parte de entender el negocio, sus necesidades y los objetivos que busca alcanzar.',
    'LET’S TALK ABOUT YOUR PROJECT': 'HABLEMOS DE TU PROYECTO',

    'DANTRIX PRO / NEXT STEP': 'DANTRIX PRO / SIGUIENTE PASO',
    'DO YOU HAVE AN IDEA IN MIND?': '¿TIENES UNA IDEA EN MENTE?',
    'We can analyze your project and develop a solution adapted to what your business needs.': 'Podemos analizar tu proyecto y desarrollar una solución adaptada a lo que tu negocio necesita.',

    'Business services': 'Servicios empresariales',

    'home': 'inicio'
};

export { translation };